import {
  SUPPORT_TICKET_CASE_CATEGORY_CHANGE,
  SUPPORT_TICKET_DESCRIPTION_CHANGE,
  SUPPORT_TICKET_DESCRIPTION_ERROR,
  SUPPORT_TICKET_MODULE_CHANGE,
  SUPPORT_TICKET_MODULE_ERROR,
  SUPPORT_TICKET_FEATURE_CHANGE,
  SUPPORT_TICKET_FEATURE_ERROR,
  SUPPORT_TICKET_FUNCTION_CHANGE,
  SUPPORT_TICKET_OPENED,
  SUPPORT_TICKET_ADD_ATTACHMENTS,
  SUPPORT_TICKET_REMOVE_ATTACHMENT,
  SUPPORT_TICKET_SUBMITTED,
  SUPPORT_TICKET_SUBMIT_ATTEMPT,
  SUPPORT_TICKET_SUBMIT_SUCCESS,
  SUPPORT_TICKET_SUBMIT_FAILURE,
  SUPPORT_TICKET_SUBMIT_UNEXPECTED_ERROR,
  SUPPORT_TICKET_SUBMIT_STATUS_CLOSE,
  SUPPORT_TICKET_SUBMIT_FIELD_ERRORS,
  SUPPORT_TICKET_ATTACHMENT_STATUS_CLOSE,
  SUPPORT_TICKET_ATTACHMENT_ERRORS,
  SUPPORT_TICKET_ATTACHMENT_DRAGGING
} from '../actions/contactSupport';

import { getModuleOptions } from '../mappings';

export const SUBMISSION_STATUS_WAITING = 'waiting';
export const SUBMISSION_STATUS_SUCCESS = 'succeeded';
export const SUBMISSION_STATUS_FAILED = 'failed';
export const SUBMISSION_STATUS_UNEXPECTED_ERROR = 'unknown-error';
export const SUBMISSION_STATUS_MISSING_REQUIRED_FIELDS = 'missing-required-fields';

export const initialState = {
  inputDescription: '',
  inputDescriptionError: null,
  inputCategory: null,
  inputModule: null,
  inputModuleError: null,
  inputFeature: null,
  inputFeatureError: null,
  inputFunction: null,
  inputErrors: null,
  attachmentErrors: null,
  attachmentErrorType: null,
  moduleOptions: getModuleOptions(),
  featureOptions: null,
  functionOptions: null,
  attachments: [],
  attachmentSizeTotal: 0,
  submitDisabled: true,
  activeAttachmentDragging: false,
  submitAttempted: false,
  submissionStatus: null,
  submissionServerResponse: null
};

export default function reducer(state = initialState, action) {
  let newAttachments;
  switch (action.type) {
    case SUPPORT_TICKET_OPENED:
      return {
        ...state,
        ...initialState,
        inputCategory: action.payload
      };
    case SUPPORT_TICKET_DESCRIPTION_ERROR:
      return {
        ...state,
        inputDescriptionError: action.payload
      };
    case SUPPORT_TICKET_DESCRIPTION_CHANGE:
      return {
        ...state,
        inputDescription: action.payload
      };
    case SUPPORT_TICKET_MODULE_CHANGE:
      return {
        ...state,
        ...action.payload
      };
    case SUPPORT_TICKET_MODULE_ERROR:
      return {
        ...state,
        inputModuleError: action.payload
      };
    case SUPPORT_TICKET_FEATURE_CHANGE:
      return {
        ...state,
        ...action.payload
      };
    case SUPPORT_TICKET_FEATURE_ERROR:
      return {
        ...state,
        inputFeatureError: action.payload
      };
    case SUPPORT_TICKET_FUNCTION_CHANGE:
      return {
        ...state,
        inputFunction: action.payload
      };
    case SUPPORT_TICKET_CASE_CATEGORY_CHANGE:
      return {
        ...state,
        inputCategory: action.payload
      };
    case SUPPORT_TICKET_ADD_ATTACHMENTS:
      //  add attachments and sort by size
      newAttachments = [...state.attachments, ...action.payload].sort((itemA, itemB) => itemB.size - itemA.size);
      return {
        ...state,
        attachments: newAttachments,
        attachmentSizeTotal: computeAttachmentSizeTotal(newAttachments)
      };
    case SUPPORT_TICKET_REMOVE_ATTACHMENT:
      newAttachments = state.attachments.filter(file => file.url !== action.payload);
      return {
        ...state,
        attachments: newAttachments,
        attachmentSizeTotal: computeAttachmentSizeTotal(newAttachments)
      };
    case SUPPORT_TICKET_ATTACHMENT_ERRORS:
      return {
        ...state,
        attachmentErrors: action.payload.errors,
        attachmentErrorType: action.payload.errorType
      };
    case SUPPORT_TICKET_SUBMIT_ATTEMPT:
      return {
        ...state,
        submitAttempted: true
      };
    case SUPPORT_TICKET_SUBMITTED:
      return {
        ...state,
        submissionStatus: SUBMISSION_STATUS_WAITING,
        submissionServerResponse: null
      };
    case SUPPORT_TICKET_SUBMIT_SUCCESS:
      return {
        ...state,
        submissionStatus: SUBMISSION_STATUS_SUCCESS
      };
    case SUPPORT_TICKET_SUBMIT_UNEXPECTED_ERROR:
      return {
        ...state,
        submissionStatus: SUBMISSION_STATUS_UNEXPECTED_ERROR,
        submissionServerResponse: action.payload
      };
    case SUPPORT_TICKET_SUBMIT_FAILURE:
      return {
        ...state,
        submissionStatus: SUBMISSION_STATUS_FAILED,
        submissionServerResponse: action.payload
      };
    case SUPPORT_TICKET_SUBMIT_STATUS_CLOSE:
      return {
        ...state,
        submissionStatus: null,
        submissionServerResponse: null
      };
    case SUPPORT_TICKET_ATTACHMENT_STATUS_CLOSE:
      return {
        ...state,
        attachmentErrors: null,
        attachmentErrorType: null
      };
    case SUPPORT_TICKET_ATTACHMENT_DRAGGING:
      return {
        ...state,
        activeAttachmentDragging: action.payload
      };
    case SUPPORT_TICKET_SUBMIT_FIELD_ERRORS:
      return {
        ...state,
        submissionStatus: SUBMISSION_STATUS_MISSING_REQUIRED_FIELDS,
        inputErrors: action.payload
      };
    default:
      return state;
  }
}

function computeAttachmentSizeTotal(attachments) {
  return attachments.reduce((total, attachment) => total + attachment.size, 0);
}
